__turbopack_context__.v({
  "richText": "qqQ05G_richText",
  "sectionContent": "qqQ05G_sectionContent",
});
